import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/complete/group/${string | ':code'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/complete/group/:code`;

export const URL = (code: string): RouteDefinition => `${baseRoute}/complete/group/${code}`;
